import styled from 'styled-components';

import Picture from 'components/picture';

import {
  StyledButton as DefaultButton,
  ButtonWrapper as StyledButtonWrapper,
  DescriptionTextBlock as StyledDescription,
  HeadingText as StyledHeading,
  TitleText as StyledTitleText,
} from './empty-state.styled.default';

export * from './empty-state.styled.default';

export const Container = styled.div`
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  text-align: center;
  ${Styles.desktop} {
    height: 100%;
    justify-content: flex-end;
  }
`;

export const ButtonWrapper = styled(StyledButtonWrapper)`
  margin-block-start: 1.5rem;
  margin-block-end: 0;
  margin-inline: auto;
  order: 5;
`;

export const StyledButton = DefaultButton;

export const DescriptionTextBlock = styled(StyledDescription)`
  color: ${Styles.color.black};
  margin-block-start: 0.5rem;
  order: 3;
`;

export const HeadingText = styled(StyledHeading)<{ isVisible: boolean }>`
  color: ${Styles.color.black};
  font-size: 2.25rem;
  order: 1;
`;

export const LogoContainer = styled(Picture)`
  height: 7rem;
  width: 100%;
  margin-block-start: 1rem;
  margin-block-end: 0;
  margin-inline: 0;
`;

export const ImageContainer = styled(Picture)`
  margin-block-start: 1rem;
  margin-block-end: 0;
  margin-inline: 0;
  order: 4;
  ${Styles.desktop} {
    height: 23rem;
  }
`;

export const TitleText = styled(StyledTitleText)<{ $fontColor?: string }>`
  color: ${p => p.$fontColor || Styles.color.black};
  order: 2;
  font-size: 1.625rem;
  ${Styles.mobileTiny} {
    /* overrides font size set by the default styles */
    font-size: 1.625rem;
  }
`;
